import { Autocomplete, TextField } from 'components/mui';
import { useState, useEffect } from 'react';
import getDispatchCustomers from 'api/getDispatchCustomers';

const CustSelector = ({ setCustomerID }) => {
	const [value, setValue] = useState('');
	const [companies, setCompanies] = useState([]);

	const onChange = (e, values) => {
		if (values) {
			setValue(values);
			setCustomerID(values.Id);
		} else {
			setValue({});
			setCustomerID('');
		}
	};

	useEffect(() => {
		(async () => {
			try {
				const _companies = await getDispatchCustomers();
				const x = {
					RowNumber: '0',
					Id: '0',
					Name: 'GLOBAL CHECKLISTS',
				};
				setCompanies([x, ..._companies]);
			} catch (error) {
				console.log('USE_USER_MGT ERROR :>> ', error);
			}
		})();
	}, []);

	return (
		<>
			<Autocomplete
				value={value}
				options={companies}
				getOptionLabel={(option) => (option.Name ? option.Name : '')}
				isOptionEqualToValue={(option, value) =>
					option.value === value.value
				}
				onChange={onChange}
				renderInput={(params) => (
					<TextField
						{...params}
						variant="outlined"
						label="Companies"
						InputLabelProps={{ shrink: true }}
					/>
				)}
			/>
		</>
	);
};

export default CustSelector;
